import './Input.css'
import cx from 'classnames'
import { DetailedHTMLProps, InputHTMLAttributes } from 'react'

export type InputSize = 'sm' | 'md'

type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  label?: string
  sizeType?: InputSize
}

// Export for other components that need input styling
export const inputSizeClasses: Record<InputSize, string> = {
  sm: 'input-sm',
  md: 'input-md'
}

// For backward compatibility
export const inputClasses = {
  fixed: 'input-base',
  sizeToClasses: inputSizeClasses
}

function generateInputClasses(sizeType: InputSize, className?: string) {
  return cx('input-base', inputSizeClasses[sizeType], className)
}

export function Input({
  id,
  value,
  disabled,
  onChange,
  onBlur,
  type,
  name,
  placeholder,
  sizeType = 'md',
  className,
  min,
  readOnly,
  maxLength
}: InputProps) {
  return (
    <input
      className={generateInputClasses(sizeType, className)}
      placeholder={placeholder}
      id={id}
      min={min}
      type={type}
      value={value}
      name={name}
      maxLength={maxLength}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      readOnly={readOnly}
    />
  )
}
